import VueCookies from 'vue-cookies'

import { InventoryService } from "@/services/nextshop/inventory.service";

export default {
  methods: {
    async getListInventory(locationId) {
      try {
        const params = {
          coMerchantId: VueCookies.get("MID"),
          coLocationId: (locationId != null) 
            ? locationId : VueCookies.get("LID"),
					limit: 100,
					page: 1,
        }
        const dataRes = await InventoryService.inventorylist(params);
        
        if (dataRes.success) {
          return dataRes.data;
        }
      } catch (error) {
        console.log(error);
      }
    },
  }
}